export default "/images/118ca73b94c0d14e06b8f20da614bd43.avif";